export const MAP_SELECTORS = {
  'frontend': {
    'totalPricePages'   : 'selectFrontendPagesTotal',
    'totalPriceOptions' : 'selectFrontendOptionsTotal',
    'totalPrice'        : 'selectFrontendTotal',
    'eta'               : 'selectFrontendEta',
    'discount'          : 'selectFrontendDiscount',
    'totalPriceForAsap' : 'selectFrontendTotalForAsap'
  },
  'frontend#order': {
    'totalPricePages'   : 'selectFrontendPagesTotal',
    'totalPriceOptions' : 'selectFrontendOptionsTotal',
    'totalPrice'        : 'selectFrontendTotal',
    'eta'               : 'selectFrontendEta',
    'discount'          : 'selectFrontendDiscount',
    'totalPriceForAsap' : 'selectFrontendTotalForAsap'
  },
  'frontend#quote': {
    'totalPricePages'   : 'selectFrontendPagesTotal',
    'totalPriceOptions' : 'selectFrontendOptionsTotal',
    'totalPrice'        : 'selectFrontendTotal',
    'eta'               : 'selectFrontendEta',
    'discount'          : 'selectFrontendDiscount',
    'totalPriceForAsap' : 'selectFrontendTotalForAsap'
  },
  'frontendSeparatePage': {
    'totalPricePages'   : 'selectFrontendPagesTotal',
    'totalPriceOptions' : 'selectFrontendOptionsTotal',
    'totalPrice'        : 'selectFrontendTotal',
    'eta'               : 'selectFrontendEta',
    'discount'          : 'selectFrontendDiscount',
    'totalPriceForAsap' : 'selectFrontendTotalForAsap'
  },
  'wordpress': {
    'totalPricePages'   : 'selectWordpressPagesTotal',
    'totalPriceOptions' : 'selectWordpressOptionsTotal',
    'totalPrice'        : 'selectWordpressTotal',
    'eta'               : 'selectWordpressEta',
    'discount'          : 'selectWordpressDiscount',
    'totalPriceForAsap' : 'selectWordpressTotalForAsap'
  },
  'wordpressSeparatePage': {
    'totalPricePages'   : 'selectWordpressSeparatePagePagesTotal',
    'totalPriceOptions' : 'selectWordpressSeparatePageOptionsTotal',
    'totalPrice'        : 'selectWordpressSeparatePageTotal',
    'eta'               : 'selectWordpressSeparatePageEta',
    'discount'          : 'selectWordpressSeparatePageDiscount',
    'totalPriceForAsap' : 'selectWordpressSeparatePageTotalForAsap'
  },
  'shopify': {
    'totalPricePages'   : 'selectShopifyPagesTotal',
    'totalPriceOptions' : 'selectShopifyOptionsTotal',
    'totalPrice'        : 'selectShopifyTotal',
    'eta'               : 'selectShopifyEta',
    'discount'          : 'selectShopifyDiscount',
    'totalPriceForAsap' : 'selectShopifyTotalForAsap'
  },
  'email#templates': {
    'totalPricePages'   : 'selectEmailTemplatesPagesTotal',
    'totalPriceOptions' : 'selectEmailTemplatesOptionsTotal',
    'totalPrice'        : 'selectEmailTemplatesTotal',
    'eta'               : 'selectEmailTemplatesEta',
    'discount'          : 'selectEmailTemplatesDiscount',
    'totalPriceForAsap' : 'selectEmailTemplatesTotalForAsap'
  },
  'email#signature': {
    'totalPricePages'   : 'selectEmailSignaturePagesTotal',
    'totalPriceOptions' : 'selectEmailSignatureOptionsTotal',
    'totalPrice'        : 'selectEmailSignatureTotal',
    'eta'               : 'selectEmailSignatureEta',
    'discount'          : 'selectEmailSignatureDiscount',
    'totalPriceForAsap' : 'selectEmailSignatureTotalForAsap'
  },
  'banners': {
    'totalPricePages'   : 'selectBannersPagesTotal',
    'totalPriceOptions' : 'selectBannersOptionsTotal',
    'totalPrice'        : 'selectBannersTotal',
    'eta'               : 'selectBannersEta',
    'discount'          : 'selectBannersDiscount',
    'totalPriceForAsap' : 'selectBannersTotalForAsap'
  },
  'hubspot': {
    'totalPricePages'   : 'selectHubspotPagesTotal',
    'totalPriceOptions' : 'selectHubspotOptionsTotal',
    'totalPrice'        : 'selectHubspotTotal',
    'eta'               : 'selectHubspotEta',
    'discount'          : 'selectHubspotDiscount',
    'totalPriceForAsap' : 'selectHubspotTotalForAsap'
  },
  'webFlow': {
    'totalPricePages'   : 'selectWebFlowPagesTotal',
    'totalPriceOptions' : 'selectWebFlowOptionsTotal',
    'totalPrice'        : 'selectWebFlowTotal',
    'eta'               : 'selectWebFlowEta',
    'discount'          : 'selectWebFlowDiscount',
    'totalPriceForAsap' : 'selectWebFlowTotalForAsap'
  },
  'design': {
    'totalPricePages'   : 'selectDesignPagesTotal',
    'totalPriceOptions' : 'selectDesignOptionsTotal',
    'totalPrice'        : 'selectDesignTotal',
    'eta'               : 'selectDesignEta',
    'discount'          : 'selectDesignDiscount',
    'totalPriceForAsap' : 'selectDesignTotalForAsap'
  },
  'other': {
    'totalPricePages'   : 'selectOtherPagesTotal',
    'totalPriceOptions' : 'selectOtherOptionsTotal',
    'totalPrice'        : 'selectOtherTotal',
    'eta'               : 'selectOtherEta',
    'discount'          : 'selectOtherDiscount',
    'totalPriceForAsap' : 'selectOtherTotalForAsap'
  },
};
